// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./font/higura.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@font-face {
  font-family: "Hiragino Maru Go Pro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* Css no copy */
.cssNoCopy {
  -moz-user-select: none !important;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  user-select: none !important;
}

html {
  overflow: hidden;
  width: 100%;
}

body {
  color: rgb(37, 37, 37);
  font-family: "Hiragino Maru Go Pro" !important;
  font-size: 1.1rem;
  height: 100%;
  position: fixed;
  width: 100vw;
  overflow-y: auto;
}

.ant-result {
  font-family: "Hiragino Maru Go Pro" !important;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,cAAA;EACA,oBAAA;AACJ;;AACA;EACI,mCAAA;EACA,4CAAA;AAEJ;AACA;EACI;IACI,4CAAA;EACN;AACF;AAEA;EACI,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI;IACI,uBAAA;EAAN;EAEE;IACI,yBAAA;EAAN;AACF;AAEA,gBAAA;AACA;EACI,iCAAA;EACA,sCAAA;EACA,oCAAA;EAIA,4BAAA;AAAJ;;AAEA;EACI,gBAAA;EACA,WAAA;AACJ;;AACA;EACI,sBAAA;EACA,8CAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,8CAAA;AAGJ","sourcesContent":[".App {\n    text-align: center;\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n@font-face {\n    font-family: 'Hiragino Maru Go Pro';\n    src: url(./font/higura.otf);\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n/* Css no copy */\n.cssNoCopy {\n    -moz-user-select: none !important;\n    -webkit-touch-callout: none !important;\n    -webkit-user-select: none !important;\n    -khtml-user-select: none !important;\n    -moz-user-select: none !important;\n    -ms-user-select: none !important;\n    user-select: none !important;\n}\nhtml {\n    overflow: hidden;\n    width: 100%;\n}\nbody {\n    color: rgb(37, 37, 37);\n    font-family: 'Hiragino Maru Go Pro' !important;\n    font-size: 1.1rem;\n    height: 100%;\n    position: fixed;\n    width: 100vw;\n    overflow-y: auto;\n}\n.ant-result {\n    font-family: 'Hiragino Maru Go Pro' !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
